import { gql } from 'graphql-tag';

export const SEND_PROMO_NOTIFICATION = gql`
    mutation SendPromoNotification($input: PromoNotificationInput!) {
        sendPromoNotification(input: $input) {
            success
            message
        }
    }
`;
